import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class UnlikePostUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(postId: string, userId: string): Promise<void> {
    logger.debug('UnlikePost', 'Unliking post', { postId, userId });

    await this.postRepository.unlikePost(postId, userId);

    logger.debug('UnlikePost', 'Successfully unliked post');
  }
}
